import React from 'react';
import { routes } from 'constants/config';
import { Button } from 'ui';

const Restore = ({ event }) => (
  <Button
    fullWidth
    small
    data-confirm={t('in_person_training.event_overview.confirmations.restore')}
    data-method="put"
    icon="restore"
    url={routes.IN_PERSON_TRAINING.RESTORE_EVENT(event.id)}
  >
    {t('common.restore')}
  </Button>
);

export default Restore;
